import { CadastroUsuario } from './../../../entity/CadastroUsuario';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CadastroService } from '../../../service/cadastro/cadastro.service';
import { PAGINA_SUCESSO_USER, PAGINA_LOGIN, EDITAR_USUARIO, PAGINA_HOME_USUARIO_INTERNO, PAGINA_HOME } from 'src/app/tools/URL';
import {  OK_DADOS_GRAVADOS, OK_DADOS_ALTERADOS, MSG_OBG_VALIDSENHA,
          MSG_OBG_SELFORM, MSG_OBG_EMAIL, MSG_OBG_VALIDEMAIL, MSG_OBG_SENHA, MSG_OBG_CONFSENHA, MSG_OBG_NOME,
          MSG_OBG_RAZAOSOCIAL, MSG_OBG_REPEMPRESA, MSG_OBG_DTNASC, MSG_OBG_CPF, MSG_OBG_CNPJ, MSG_OBG_ESCOL,
          MSG_OBG_CEP, MSG_OBG_NUM, ERRO_FORMATO_EMAIL_INVALIDO, ERRO_BUSCA_CEP, MSG_OBG_LOGRADOURO, MSG_CNPJ_INVALIDO, MSG_CPF_INVALIDO} from 'src/app/tools/Mensagens';
import { BuscaCep } from 'src/app/entity/BuscaCep';
import { PesquisarUsuarioService } from 'src/app/service/usuario/pesquisar-usuario.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { KeycloakService } from 'keycloak-angular';
import { Location } from '@angular/common';
import { AbstractControl,  FormBuilder,  FormControl,  FormGroup,  Validators,} from '@angular/forms';
import { isCNPJ } from 'validation-br';
import { isCPF } from 'validation-br';


const CURRENT_USER = 'CurrentUser';
const CANAL_UNICO = 'CANAL_UNICO';
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css']
})

export class CadastroComponent implements OnInit {

  alerts = '';

  listaCBOs = [{ cbo: '', titulo: ''}];

  hidethis = true;

  enderecoManualDisabled: boolean;
  emailOriginal: string;

  visualizacao = this.router.url === EDITAR_USUARIO;
  edicaoOperador = false;


  senha = new FormControl(null, [
    (c: AbstractControl) => Validators.required(c),
    Validators.pattern(
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+-.={}|:;"'<>,?/]).{8,}/

    ),
  ]);
  confirmacaoSenha = new FormControl(null, [
    (c: AbstractControl) => Validators.required(c),
    Validators.pattern(
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+-.={}|:;"'<>,?/]).{8,}/
    ),
  ]);

  validacaoSenha = this.formBuilder.group(
    {
      senha: this.senha,
      confirmacaoSenha: this.confirmacaoSenha,
    },
    {
      validator: this.ConfirmedValidator('senha', 'confirmacaoSenha'),
    }
  );

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors.confirmedValidator
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  constructor(
      public cadastroService: CadastroService,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private keycloakService: KeycloakService,
      private authService: AuthService,
      private location: Location,
      private pesquisarUsuarioService: PesquisarUsuarioService,
      private formBuilder: FormBuilder
    ) {

    //Campo setado como false após a retirada da obrigatoriedade do campo CEP - SOLSEI-864
    //this.enderecoManualDisabled = true;
    this.enderecoManualDisabled = false;
    this.cadastroService.cadastroUsuario = this.router.url === EDITAR_USUARIO ? this.usuarioEditado() : new CadastroUsuario();

    if (this.activatedRoute.snapshot.params.id) {

      const id = this.activatedRoute.snapshot.params.id;
      pesquisarUsuarioService.findById(id).subscribe((usuario: CadastroUsuario) => {

        this.edicaoOperador = true;
        this.cadastroService.cadastroUsuario = usuario;

        if(this.cadastroService.cadastroUsuario) {

          this.emailOriginal = usuario.email;
          this.cadastroService.cadastroUsuario.confirmacaoEmail = this.cadastroService.cadastroUsuario.email;

        }

      }
      , err => {

        alert(JSON.parse(err.error).message);
        this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

      });

    }

  }

  paises: any[] = [];        // Lista de UFs
  ufs: any[] = [];        // Lista de UFs
  municipios: any[] = []; // Lista de municípios da UF selecionada
  selectedUf: string = ''; // UF selecionada

  ngOnInit() {
    this.cadastroService.getPaises().subscribe((data: any) => {
      const brasil = data.find(pais => pais.nome === 'Brasil'); // Encontrar o Brasil na lista
      const listaPaises = data.filter(pais => pais.nome !== 'Brasil'); // Remover o Brasil da lista original
      this.paises = [brasil, ...listaPaises]; // Adicionar o Brasil no início da lista
    });
    this.cadastroService.getUfs().subscribe((data: any) => {
      const mg = data.find(uf => uf.sigla === 'MG'); // Encontrar o MG na lista
      const listaUFs = data.filter(uf => uf.sigla !== 'MG'); // Remover o MG da lista original
      this.ufs = [mg, ...listaUFs]; // Adicionar o MG no início da lista
    });
  }

  onUfChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedUf = selectElement.value;
    if (this.selectedUf) {
      this.cadastroService.getMunicipios(this.selectedUf).subscribe((data: any) => {
        this.municipios = data;
      });
    } else {
      this.municipios = [];
    }
  }


  voltar() {

    this.keycloakService.isLoggedIn().then(isLoggedIn => {

      if (!isLoggedIn && !this.authService.isUsuarioExternoLogado()) {

        this.router.navigate([PAGINA_LOGIN]);

      } else {

        this.location.back();

      }

    });

  }

  extrairMensagemErro(retorno: any): string {
    if (!retorno) {
      return '';
    }

    if (typeof retorno === 'string') {
      return retorno;
    }

    if (Array.isArray(retorno)) {
      const mensagens = retorno
        .map((erro: any) => this.extrairMensagemErro(erro))
        .filter((mensagem: string) => mensagem && mensagem.trim().length > 0);

      return mensagens.join('\n');
    }

    if (typeof retorno === 'object') {
      if (retorno.mensagem) {
        return retorno.mensagem;
      }

      if (retorno.message) {
        return retorno.message;
      }

      if (retorno.error) {
        return this.extrairMensagemErro(retorno.error);
      }

      if (retorno.errors && Array.isArray(retorno.errors)) {
        return retorno.errors.join('\n');
      }
    }

    return '';
  }

  onSubmit() {

    if (this.validarFormulario(this.visualizacao)) {

      this.cadastroService.cadastroUsuario.origem = CANAL_UNICO;

      if (this.edicaoOperador &&
        this.cadastroService.cadastroUsuario.email !== this.emailOriginal &&
        !this.authService.possuiRoles(['ADMINISTRADOR_COSIP'])) {

        alert("Seu perfil não tem permissão para alterar e-mail.");

        return;
      }

      this.cadastroService.salvar(this.cadastroService.cadastroUsuario).subscribe((retorno: any) => {

        const mensagemErro = this.extrairMensagemErro(retorno);
        const teveErro = !!retorno && (
          retorno.error !== undefined ||
          retorno.mensagem !== undefined ||
          retorno.message !== undefined ||
          Array.isArray(retorno)
        );

        if (teveErro && mensagemErro) {

          alert(mensagemErro);

          return;

        }

        if (this.visualizacao) {

          this.cadastroService.cadastroUsuario.senha = null;
          localStorage.setItem(CURRENT_USER, JSON.stringify(this.cadastroService.cadastroUsuario));

          alert(OK_DADOS_ALTERADOS);
          this.router.navigate([PAGINA_HOME]);

          return;

        } else if (this.edicaoOperador) {

          alert(OK_DADOS_ALTERADOS);
          this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

          return;

        }

        if (this.authService.isUsuarioGovBr()) {
          this.cadastroService.cadastroUsuario.senha = null;
          localStorage.setItem(CURRENT_USER, JSON.stringify(this.cadastroService.cadastroUsuario));

          alert(OK_DADOS_GRAVADOS);
          const redirecionamentoPosCadastro = this.authService.consumirRedirecionamentoGovBr();
          this.router.navigateByUrl(redirecionamentoPosCadastro);
          return;
        }

        alert(OK_DADOS_GRAVADOS);
        this.router.navigate([PAGINA_SUCESSO_USER]);

      });

    } else {

      alert(this.alerts);

    }

  }

  usuarioEditado(): CadastroUsuario {
    if (localStorage.getItem(CURRENT_USER)) {
      return JSON.parse(localStorage.getItem(CURRENT_USER));
    }
  }

  complete(textoPesquisa: string) {

    this.listaCBOs =  [{ cbo: '', titulo: ''}];

    if (textoPesquisa.length > 4) {
      this.buscaCBOs(textoPesquisa);
      this.hidethis = false;
    }

  }

  buscaCBOs(textoPesquisa: string) {

    this.cadastroService.buscarCBOs(textoPesquisa).subscribe(( retorno: [{ cbo: string, titulo: string}]) => {
      this.listaCBOs = retorno;
    });

  }

  buscarCep() {

    this.cadastroService.buscarCep(this.cadastroService.cadastroUsuario.cep).subscribe((retorno: BuscaCep ) => {

      this.limparCep();

      if (!retorno.erro) {

        if (retorno.logradouro === '' || retorno.logradouro === null || retorno.logradouro === undefined) {

          this.enderecoManualDisabled = false;

        }

        this.cadastroService.cadastroUsuario.cep = retorno.cep;
        this.cadastroService.cadastroUsuario.logradouro = retorno.logradouro;
        this.cadastroService.cadastroUsuario.complemento = retorno.complemento;
        this.cadastroService.cadastroUsuario.bairro = retorno.bairro;
        this.cadastroService.cadastroUsuario.municipio = retorno.localidade;
        this.cadastroService.cadastroUsuario.uf = retorno.uf;
        this.cadastroService.cadastroUsuario.pais = 'Brasil';

      } else {

        alert(ERRO_BUSCA_CEP);
        this.enderecoManualDisabled = false;

      }

    }, () => {

      alert(ERRO_BUSCA_CEP);
      this.enderecoManualDisabled = false;

    });

  }

  limparCep() {

    this.cadastroService.cadastroUsuario.cep = null;
    this.cadastroService.cadastroUsuario.logradouro = null;
    this.cadastroService.cadastroUsuario.numero = null;
    this.cadastroService.cadastroUsuario.complemento = null;
    this.cadastroService.cadastroUsuario.bairro = null;
    this.cadastroService.cadastroUsuario.municipio = null;
    this.cadastroService.cadastroUsuario.uf = null;
    this.cadastroService.cadastroUsuario.pais = null;
    this.selectedUf = null;

  }

  validarFormulario(visualizacao) {

    this.alerts = '';

    if (!visualizacao) {

      if (!EMAIL_REGEX.test(this.cadastroService.cadastroUsuario.email)) {
        this.alerts = this.alerts + '\n' + ERRO_FORMATO_EMAIL_INVALIDO;
      }

      if (!this.cadastroService.cadastroUsuario.email || this.cadastroService.cadastroUsuario.email.length <= 0) {
        this.alerts = this.alerts + '\n' + MSG_OBG_EMAIL;

      }

      if (!this.cadastroService.cadastroUsuario.confirmacaoEmail || this.cadastroService.cadastroUsuario.confirmacaoEmail.length <= 0) {
        this.alerts = this.alerts + '\n' + MSG_OBG_VALIDEMAIL;

      }

      if (!this.edicaoOperador) {

        if (this.cadastroService.cadastroUsuario.email !== this.cadastroService.cadastroUsuario.confirmacaoEmail) {

          this.alerts = this.alerts + '\n' + MSG_OBG_VALIDEMAIL;

        }

        if (!this.cadastroService.cadastroUsuario.senha || this.cadastroService.cadastroUsuario.senha.length <= 0) {
          this.alerts = this.alerts + '\n' + MSG_OBG_SENHA;
        }

        if (!this.cadastroService.cadastroUsuario.confirmacaoSenha || this.cadastroService.cadastroUsuario.confirmacaoSenha.length <= 0) {

          this.alerts = this.alerts + '\n' + MSG_OBG_CONFSENHA;

        }
        else if (this.cadastroService.cadastroUsuario.senha !== this.cadastroService.cadastroUsuario.confirmacaoSenha) {

          this.alerts = this.alerts + '\n' + MSG_OBG_VALIDSENHA;

        }

      }

    }

    if (!this.cadastroService.cadastroUsuario.tipoDocumento || this.cadastroService.cadastroUsuario.tipoDocumento.length <= 0) {
      this.alerts = this.alerts + '\n' + MSG_OBG_SELFORM;
    }

    if (this.cadastroService.cadastroUsuario.tipoDocumento === 'CPF') {

      if (!this.cadastroService.cadastroUsuario.nome || this.cadastroService.cadastroUsuario.nome.length <= 0) {
        this.alerts = this.alerts + '\n' + MSG_OBG_NOME;
      }

      //Marcus - SOLSEI-934
      //if (!this.cadastroService.cadastroUsuario.cpfcnpj || this.cadastroService.cadastroUsuario.cpfcnpj.length <= 0) {
      if (!this.cadastroService.cadastroUsuario.cpfcnpj || this.cadastroService.cadastroUsuario.cpfcnpj.length < 11) {
        this.alerts = this.alerts + '\n' + MSG_OBG_CPF;
      }

      if(isCPF(this.cadastroService.cadastroUsuario.cpfcnpj) === false) {
        this.alerts = this.alerts + '\n' + MSG_CPF_INVALIDO;
      }

    }

    if (this.cadastroService.cadastroUsuario.tipoDocumento === 'CNPJ' ) {

      //Marcus - SOLSEI-934
      //if (!this.cadastroService.cadastroUsuario.cpfcnpj || this.cadastroService.cadastroUsuario.cpfcnpj.length <= 0 ) {
      if (!this.cadastroService.cadastroUsuario.cpfcnpj || this.cadastroService.cadastroUsuario.cpfcnpj.length < 14 ) {
        this.alerts = this.alerts + '\n' + MSG_OBG_CNPJ;
      }

      if(isCNPJ(this.cadastroService.cadastroUsuario.cpfcnpj) === false) {
        this.alerts = this.alerts + '\n' + MSG_CNPJ_INVALIDO;
      }


    }

    if (this.alerts.length > 0) {
      return false;
    }

    return true;

  }

  limparCampos() {
    this.cadastroService.cadastroUsuario.nome = '';
    this.cadastroService.cadastroUsuario.nomeSocial = '';
    this.cadastroService.cadastroUsuario.cpfcnpj = '';
    this.cadastroService.cadastroUsuario.dataNascimento = null;
    this.cadastroService.cadastroUsuario.genero = null;
    this.cadastroService.cadastroUsuario.escolaridade = '';
    this.cadastroService.cadastroUsuario.nomeResponsavel = '';
    this.cadastroService.cadastroUsuario.contatoResponsavel = '';
    this.cadastroService.cadastroUsuario.nomeDoRepresentante = '';
    this.cadastroService.cadastroUsuario.atividadeEconomica = '';
    this.cadastroService.cadastroUsuario.telefoneResid = '';
  }

  limparCamposAtualizacaoPais() {

    if(this.cadastroService.cadastroUsuario.pais != 'Brasil'
      && this.cadastroService.cadastroUsuario.pais != ''
      && this.cadastroService.cadastroUsuario.pais != undefined) {

      this.cadastroService.cadastroUsuario.cep = null;
      this.cadastroService.cadastroUsuario.logradouro = null
      this.cadastroService.cadastroUsuario.numero = null
      this.cadastroService.cadastroUsuario.complemento = null
      this.cadastroService.cadastroUsuario.bairro = null
      this.cadastroService.cadastroUsuario.uf = null
      this.cadastroService.cadastroUsuario.municipio = null
      this.selectedUf = null;
    }

  }

}
